export default __webpack_public_path__ + "static/media/6-3.583fee88.png";